import React from 'react';
import { SidebarProvider } from './ui/sidebar';
import { AppSidebar } from './AppSidebar';

interface AdminLayoutProps {
  currentView: string;
  onViewChange: (view: string) => void;
  onLogout: () => void;
  children: React.ReactNode;
}

export const AdminLayout: React.FC<AdminLayoutProps> = ({ currentView, onViewChange, onLogout, children }) => {
  return (
    <SidebarProvider defaultOpen={true}>
      <div className="min-h-screen flex w-full">
        <AppSidebar
          currentView={currentView}
          onViewChange={onViewChange}
          onLogout={onLogout}
        />
        <main className="flex-1 p-6 bg-gray-50">
          {children}
        </main>
      </div>
    </SidebarProvider>
  );
};
